<template>
  <div class="demand_box">
    <div class="owner_title">修改书籍信息</div>
    <div class="owner_box">
      <el-form
        ref="editInfoForm"
        :rules="rules"
        :model="editInfoForm"
        label-width="130px"
      >
        <el-form-item label="金主昵称">
          <div class="username">{{ user_name }}</div>
        </el-form-item>
        <el-form-item label="书名" prop="name">
          <el-input class="inpt_size" v-model="editInfoForm.name"></el-input>
        </el-form-item>
        <el-form-item label="金主给千字价格" prop="actual_cost">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.actual_cost"
          ></el-input>
        </el-form-item>
        <el-form-item label="每章字数" prop="each_chapter_num">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.each_chapter_num"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择写手:" prop="nickname">
          <el-select
            v-model="editInfoForm.nickname"
            @change="selectWriter($event)"
          >
            <el-option
              v-for="item in writerList"
              :key="item.id"
              :label="item.nickname"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态" prop="is_task">
          <el-radio-group v-model="editInfoForm.is_task">
            <el-radio :label="1">进行中</el-radio>
            <el-radio :label="2">已完结</el-radio>
            <el-radio :label="-1">已停止</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="日周结" prop="settlement_type">
          <el-radio-group v-model="editInfoForm.settlement_type">
            <el-radio :label="1">日结</el-radio>
            <el-radio :label="2">周结</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="c_remarks">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.c_remarks"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="book_edit_btn">
            <el-button
              class="info_btn"
              type="primary"
              round
              @click="onSubmiOwnerDwmand"
              >确认修改</el-button
            >
            <el-button class="info_btn" type="info" plain round @click="goBack"
              >取消</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { edit_connectionessay, writer_list } from "@/utils/owner";
export default {
  data() {
    return {
      user_name: "", //用户名称
      editdata: "", //参数对象
      writerList: [], //写手列表
      editInfoForm: {
        departmentuser_id: "", //所属金主部id
        name: "", //书名
        actual_cost: "", //金主给千字价格
        c_remarks: "", //备注
        each_chapter_num: "", //每章字数
        is_task: "", //任务状态
        settlement_type: "", //日周结
        writeradmin_id: "", //写手编辑
        nickname: "", //写手名称
        filterData: "" //筛选数据
      },
      rules: {
        actual_cost: [
          {
            required: true,
            trigger: "blur",
            message: "金主给千字价格不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "价格只能是数字" }
        ],
        each_chapter_num: [
          {
            required: true,
            trigger: "blur",
            message: "每章字数不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "字数格式不正确" }
        ],
        is_task: {
          required: true,
          trigger: "blur",
          message: "任务状态不能为空"
        },
        settlement_type: {
          required: true,
          trigger: "blur",
          message: "日周结不能为空"
        },
        nickname: { required: true, trigger: "blur", message: "写手不能为空" }
      }
    };
  },
  created() {
    this.editdata = JSON.parse(this.$route.query.data);
    this.filterData = JSON.parse(this.$route.query.filter);
    this.user_name = JSON.parse(localStorage.getItem("userInfo")).nickname;
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getData();
    this.getWriter();
  },
  methods: {
    // 获取数据
    getData() {
      var that = this;
      that.editInfoForm.departmentuser_id = this.ownerId;
      that.editInfoForm.connectionessay_id = this.editdata.id;
      that.editInfoForm.name = this.editdata.connectionessay_name;
      that.editInfoForm.actual_cost = this.editdata.actual_cost;
      that.editInfoForm.each_chapter_num = this.editdata.each_chapter_num;
      that.editInfoForm.is_task = this.editdata.is_task;
      that.editInfoForm.settlement_type = this.editdata.settlement_type;
      that.editInfoForm.nickname = this.editdata.writeradmin_name;
      that.editInfoForm.writeradmin_id = this.editdata.writeradmin_id;
    },
    // 获取写手列表
    getWriter() {
      var that = this;

      writer_list().then(res => {
        if (res.data.code == 1) {
          that.writerList = res.data.data;
          console.log(that.writerList);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 选择写手
    selectWriter(val) {
      var that = this;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
      that.editInfoForm.writeradmin_id = val;
    },
    // 表单提交
    onSubmiOwnerDwmand() {
      var that = this;
      that.editInfoForm.departmentuser_id = that.ownerId;

      let obj = {
        ...that.editInfoForm
      };
      //修改金主信息
      edit_connectionessay(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          this.$route.params.filter = this.filterData;
          this.$router.push({ path: "/OwnerBookInfo" });
          // this.$router.back();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    //   取消返回首页
    goBack() {
      var that = this;
      this.$route.params.filter = this.filterData;
      this.$route.params.edit_id = 1;
      this.$router.push({ path: "/OwnerBookInfo" });

      // this.$router.back();
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.demand_box {
  background-color: #ffffff;
  height: 100%;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.username {
  font-size: 17px;
  font-weight: 600;
}
.owner_box {
  padding: 45px 30px;
}
.owner_box .el-form-item__label {
  width: 135px !important;
}
.el-main {
  padding: 0;
}
.inpt_size {
  width: 200px;
}
.upload_size {
  width: 230px;
}
.upload_icon {
  font-size: 15px;
  margin-right: 5px;
}
.info_btn {
  width: 200px;
  height: 35px;
}
.task_upload_btn {
  background: #f4f8fc;
  width: 150px;
}
.book_edit_btn {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerBookInfoEdit.vue